import { createContext } from 'react';
import type { UserDto } from '../api';
import type { StoredTokens } from './tokenStorage';

export interface AuthContextValue {
  tokens: StoredTokens | null;
  // user is populated after login; null on page reload (not persisted separately).
  // Acceptable because the current dashboard UI does not display user profile info.
  user: UserDto | null;
  // Called by any login-flow path that produces tokens (direct, MFA challenge, enrollment).
  authenticate: (tokens: StoredTokens, user: UserDto | null) => void;
  logout: () => void;
}

export const AuthContext = createContext<AuthContextValue | null>(null);
